import type { StaffRole, StaffStatus } from '@planuze/admin-contracts';
import {
  STAFF_MANAGEMENT_CONTENT,
  type StaffRoleLabels,
  type StaffStatusLabels,
} from '../../content/sections/staff-management.js';

/** Papéis na ordem de exibição (mais privilégio → menos). Não é texto — não entra no catálogo. */
export const STAFF_ROLES: readonly StaffRole[] = [
  'super_admin',
  'support',
  'billing_ops',
  'readonly',
];

/* `switch` em vez de indexação por `StaffRole` — o enum inclui `super_admin`/`billing_ops`
   (snake_case do backend) e o catálogo bilíngue usa campos em camelCase (`superAdmin`,
   `billingOps`) para não esbarrar em `useNamingConvention` (mesmo idioma de
   `pack-submission-status.ts`). */

/**
 * Rótulo do papel no idioma corrente.
 *
 * `labels` é `useStaffManagementContent().roleLabels`; o default pt-BR cobre chamadores fora de
 * componente (testes unitários).
 */
export function staffRoleLabel(
  role: StaffRole,
  labels: StaffRoleLabels = STAFF_MANAGEMENT_CONTENT['pt-BR'].roleLabels,
): string {
  switch (role) {
    case 'super_admin':
      return labels.superAdmin;
    case 'support':
      return labels.support;
    case 'billing_ops':
      return labels.billingOps;
    case 'readonly':
      return labels.readonly;
  }
}

/** Descrição do papel no idioma corrente — mesma regra de default de `staffRoleLabel`. */
export function staffRoleDescription(
  role: StaffRole,
  descriptions: StaffRoleLabels = STAFF_MANAGEMENT_CONTENT['pt-BR'].roleDescriptions,
): string {
  switch (role) {
    case 'super_admin':
      return descriptions.superAdmin;
    case 'support':
      return descriptions.support;
    case 'billing_ops':
      return descriptions.billingOps;
    case 'readonly':
      return descriptions.readonly;
  }
}

/** Rótulo do status no idioma corrente — mesma regra de default de `staffRoleLabel`. */
export function staffStatusLabel(
  status: StaffStatus,
  labels: StaffStatusLabels = STAFF_MANAGEMENT_CONTENT['pt-BR'].statusLabels,
): string {
  return status === 'active' ? labels.active : labels.suspended;
}
